<template>
  <v-container fill-height fluid>
    <!-- 로그아웃 버튼 영역 -->
    <v-row
      class="justify-end pa-4"
      style="position: absolute; top: 0; right: 0; z-index: 10"
    >
      <v-menu offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon large v-bind="attrs" v-on="on" color="primary">
            <v-icon size="32">mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="handleLogout">
            <v-list-item-icon>
              <v-icon color="error">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>로그아웃</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-row>

    <v-row
      class="fill-height px-0 pb-15"
      align="center"
      justify="space-between"
    >
      <v-col class="text-center">
        <div
          class="wc-direction-text wc-bold-900 wc-fs-28 primary--text organization-name"
        >
          {{ formatOrganizationName(userInfo.roles[0].organizationName) }}
        </div>
      </v-col>

      <v-col cols="12" class="text-center mt-9 px-20">
        <v-card
          :class="{
            'wc-card': true,
            'mb-12': true,
            'disabled-card': !service.isActive,
          }"
          v-for="service in filteredServices"
          :key="service.id"
        >
          <v-icon size="130" class="ma-3 mt-6 fadeIn" color="#262626">
            {{ service.icon }}
          </v-icon>
          <div class="wc-h3 ma-0 pa-0">{{ service.name }}</div>
          <div class="wc-info-light ma-0 pa-1 pb-7">
            {{ service.nameEn }}
          </div>
          <div class="wc-fs-16 ma-0 pa-0 px-15 pb-7">
            {{ service.description }}
          </div>
          <v-card-actions class="ma-0 pa-0">
            <v-btn
              class="wc-card-btn"
              block
              large
              @click="$router.push(service.path)"
              :disabled="!service.isActive"
            >
              <span class="wc-h3">선택하기</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { UserOrganizationsAndRolesCtrl } from '@/mixins/apis_v2/utility/UserOrganizationsAndRolesCtrl';
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'ServiceSelectionView',
    mixins: [UserOrganizationsAndRolesCtrl],
    computed: {
      ...mapState('auth', ['userInfo']),

      // 사용자 권한에 따라 필터링된 서비스 목록을 반환
      filteredServices() {
        if (
          !this.userInfo ||
          !this.userInfo.roles ||
          this.userInfo.roles.length === 0
        ) {
          return [];
        }

        const userPermissionName = this.userInfo.roles[0].roleName;

        return this.services.filter((service) =>
          this.hasPermissionForService(service, userPermissionName)
        );
      },
    },
    data() {
      return {
        services: [
          {
            id: 1,
            name: '재적인원관리',
            nameEn: 'Management of members',
            description:
              '신규인원을 등록하고 인원들의 정보를 수정/관리해보세요',
            icon: 'mdi-account-multiple-check',
            isActive: true,
            path: '/member-list',
          },
          {
            id: 2,
            name: '모임기록관리',
            nameEn: 'Meeting History Management',
            description: '모임 히스토리를 확인하고 관리할 수 있습니다.',
            icon: 'mdi-account-group',
            isActive: true,
            path: '/meeting-history',
            permissions: {
              roles: ['admin', '부순장', '순장', '부그룹장', '그룹장'],
            },
          },
          {
            id: 3,
            name: '심방 보고서',
            nameEn: 'Visit Report',
            description: '심방 보고서를 확인하고 작성할 수 있습니다.',
            icon: 'mdi-account-group',
            isActive: true,
            path: '/visit-report',
            permissions: {
              // roles: ['admin', '부순장', '순장', '부그룹장', '그룹장'],
              roles: ['admin'],
            },
          },
          // {
          //   id: 4,
          //   name: "장결자 및 새가족관리",
          //   nameEn: "Management of deceased and new families",
          //   description: "장결자 및 새가족의 심방정보를 입력하고 관리해보세요",
          //   icon: "mdi-account-supervisor-circle",
          //   isActive: true,
          //   path: "/lost-and-new-management-selection", // path 속성 추가
          // },
        ],
      };
    },
    methods: {
      ...mapActions('auth', ['logout']),

      /**
       * 로그아웃 처리 함수
       * - localStorage에 저장된 모든 인증 정보 삭제
       * - Vuex store의 인증 상태 초기화
       * - 로그인 페이지로 리다이렉트
       */
      handleLogout() {
        try {
          // 1. localStorage에서 인증 관련 정보 삭제
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('coramdeoAuth');

          // 2. Vuex store의 인증 상태 초기화
          this.logout();

          // 3. 로그인 페이지로 리다이렉트
          this.$router.push({ name: 'LoginView' });
        } catch (error) {
          console.error('로그아웃 중 오류 발생:', error);
          // 오류가 발생해도 로그인 페이지로 이동
          this.$router.push({ name: 'LoginView' });
        }
      },

      formatOrganizationName(name) {
        // '_' 기준으로 분리
        const parts = name.split('_');
        // '코람데오'와 '237국' 부분을 제거하고 나머지 부분만 줄바꿈으로 조인
        return parts.slice(2).join('\n');
      },

      /**
       * 사용자가 특정 서비스에 접근할 권한이 있는지 확인합니다.
       * @param {Object} service - 확인할 서비스 객체
       * @param {string} userPermissionName - 사용자의 역할
       * @param {string} organizationName - 사용자의 조직명
       * @returns {boolean} 접근 권한 여부
       */
      hasPermissionForService(service, userPermissionName) {
        // 권한 설정이 없는 서비스는 모든 사용자에게 허용
        if (
          !service.permissions ||
          userPermissionName === 'admin' ||
          this.userInfo.name === '임예원'
        ) {
          return true;
        }

        const roles = service.permissions.roles;

        if (roles && roles.length > 0) {
          if (roles.includes(userPermissionName)) {
            return true;
          }
          return false;
        }

        return false;
      },
    },
    mounted() {
      if (!this.userInfo) {
        this.$router.push({ name: 'LoginView' });
      }
    },
  };
</script>

<style scoped>
  .service-card {
    padding: 20px;
    margin-bottom: 20px;
  }

  .disabled-card {
    opacity: 0.5;
  }

  .custom-button {
    background-image: linear-gradient(to right, #cbdaf7, #96f2e4) !important;
    border-radius: 50px;
    color: rgb(83, 83, 83);
  }

  /* 로고 색상 기반 버튼 스타일 */
  .wc-card-btn {
    border-radius: 12px !important;
    font-weight: bold !important;
    text-transform: none !important;
    /* Vuetify 테마 색상으로 그라데이션 */
    background: linear-gradient(
      135deg,
      var(--v-gradientStart-base) 0%,
      var(--v-gradientMiddle-base) 50%,
      var(--v-gradientEnd-base) 100%
    ) !important;
    box-shadow: 0 4px 15px var(--v-shadowMedium-base),
      inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
    border: none !important;
    position: relative;
    overflow: hidden;
    color: white !important;
  }

  /* 버튼 위에 빛나는 효과 */
  .wc-card-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transition: left 0.6s ease;
  }

  /* 버튼 호버 효과 */
  .wc-card-btn:hover:not(:disabled) {
    background: linear-gradient(
      135deg,
      var(--v-hoverGradientStart-base) 0%,
      var(--v-hoverGradientMiddle-base) 50%,
      var(--v-hoverGradientEnd-base) 100%
    ) !important;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px var(--v-shadowStrong-base),
      inset 0 1px 0 rgba(255, 255, 255, 0.3) !important;
  }

  /* 호버시 빛나는 효과 */
  .wc-card-btn:hover::before {
    left: 100%;
  }

  /* 버튼 클릭 효과 */
  .wc-card-btn:active {
    transform: translateY(0px);
    box-shadow: 0 2px 10px var(--v-shadowMedium-base),
      inset 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  }

  /* 비활성화된 버튼 */
  .wc-card-btn:disabled {
    background: linear-gradient(
      135deg,
      var(--v-disabledStart-base) 0%,
      var(--v-disabledMiddle-base) 50%,
      var(--v-disabledEnd-base) 100%
    ) !important;
    color: var(--v-disabledText-base) !important;
    box-shadow: none !important;
    transform: none !important;
  }

  /* 버튼 텍스트 스타일 */
  .wc-card-btn .wc-h3 {
    color: black !important;
    font-weight: bold !important;
    text-shadow: 0 1px 2px rgba(255, 255, 255, 0.3);
  }

  .organization-name {
    white-space: pre-line;
    line-height: 1.4;
    max-width: 100%;
    padding: 0 20px;
  }
</style>
